export const theme = {
  white: '#FFFFFF',
  purple: '#4605FF',
  hoverPurple: '#3e15b3',
  backgroundGrey: '#10191B',
  darkGrey: '#3c434d',
  lightGrey: '#B2BECD',
  mainBordeRadius: '20px',
  hackyBordeRadius: '22px',
  roundedBorderRadius: '50px',
  softShadow:
    '-5px -5px 11px rgba(113, 113, 113, 0.15), 5px 5px 11px rgba(0, 0, 0, 0.15)',
  spacingXS: '1.5rem',
  spacingS: '3rem',
  spacingM: '6rem',
  spacingL: '9rem',
  spacingXL: '13rem',
  spacingMega: '20rem',
  spacingContent: '30rem',
  containerS: '75%',
  containerM: '80%',
  containerL: '85%',
}

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  mobileXL: '550px',
  tablet: '768px',
  laptop: '1024px',
  laptopM: '1250px',
  laptopL: '1440px',
  desktop: '1920px',
  desktopL: '2560px',
}

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  mobileXL: `(max-width: ${size.mobileXL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopM: `(max-width: ${size.laptopM})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
}
